import tr from 'date-fns/locale/tr';
import enUS from 'date-fns/locale/en-US';
import getSelectedLocale from '../../../lang/helpers/getSelectedLocale';

const getSelectedLocaleLanguage = () => {
  const locale = getSelectedLocale();

  return locale === 'tr' ? tr : enUS;
};

export default getSelectedLocaleLanguage;
